import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import LoaderLanding from './components/LoaderLanding/LoaderLanding';
import ProductsShowcase from './components/Products/ProductsShowcase';
import Footer from './components/Footer';
import { updateDataLayer, trackPageView } from './analytics';
import RotateOverlay from './components/RotateOverlay/RotateOverlay';

function App() {
  const [stage, setStage] = useState('landing'); // 'landing' | 'products'
  const [showLogo, setShowLogo] = useState(false);
  const [currentInitials, setCurrentInitials] = useState("ABC");
  const [isPortraitMode, setIsPortraitMode] = useState(false);
  const [hideSubtitle, setHideSubtitle] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      setTimeout(() => {
        const isPhone = Math.min(window.innerWidth, window.innerHeight) <= 430;
        const w = window.innerWidth;
        const h = window.innerHeight;
        if (isPhone) {
          const isLandscape = w > h;
          setIsPortraitMode(isLandscape);
          setHideSubtitle(isLandscape);
        } else {
          setIsPortraitMode(h > w);
          setHideSubtitle(false);
        }
      }, 100);
    };

    checkOrientation();
    const onOrientationChange = () => { checkOrientation(); };
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', onOrientationChange);
    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', onOrientationChange);
    };
  }, []);

  const handleLoaderComplete = (initials) => {
    if (initials) {
      setCurrentInitials(initials);
    }
    updateDataLayer({
      page_template: 'products',
      page_type: 'products_list',
      pagename: '/products'
    });
    trackPageView({
      page_template: 'products',
      page_type: 'products_list',
      pagename: '/products'
    });
    setStage('products');
  };

  const handleModalShow = () => {
    setShowLogo(true);
  };

  return (
    <div className={`App ${isPortraitMode ? 'portrait-mode' : ''}`}>
      <div className={`app-content ${isPortraitMode ? 'blurred' : ''}`}>
        {showLogo && <Header showLogo={showLogo} />}
        {stage === 'landing' && <LoaderLanding onComplete={handleLoaderComplete} onModalShow={handleModalShow} />}
        {stage === 'products' && <ProductsShowcase initialInitials={currentInitials} onPsInnerActive={() => {}} />}
        {showLogo && <Footer />}
      </div>
      <RotateOverlay show={isPortraitMode} hideSubtitle={hideSubtitle} />
    </div>
  );
}

export default App;
